import { gql } from '@apollo/client';
import { insuranceFragment, hotelFragment } from 'store/fragments';
import { booking, leg, passenger, product } from '../queries/GET_BOOKING';

export default gql`
  mutation revertChange($bookingReference: String!) {
    revertChange(bookingReference: $bookingReference) {
      cancellable
      ${booking}
    }
  }

  ${insuranceFragment}

  ${hotelFragment}

  ${leg}

  ${passenger}

  ${product}
`;
